import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { SelectWithTable } from 'app/views/components/inputs/selects/CustomSelectWithTable';
import { EntityParams } from 'app/models/entity-params';
import { useTradePageEntityTypes } from 'app/views/pages/trade-entry/detail-trade/use-trade-page-lookups';
import { TradeEntryEntityTable } from './trade-entry-entity-table-allocation';

type Props = {
  data: EntityParams[];
  selectEntity: (value: string | null) => void;
};

export function TradeEntryEntitySearch({
  data,
  selectEntity,
}: Props) {


  const entityTypes = useTradePageEntityTypes();

  // Map entities to include their entity type name.
  const entitiesWithTypeName = useMemo(() => {
    return data.map(entity => ({
      ...entity,
      entityTypeName:
        entityTypes.find(type => type.id === entity?.entityType?.id)?.name ?? '',
    }));
  }, [data, entityTypes]);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  // Compute the filtered entities based on the search value.
  const filteredEntities = useMemo(() => {
    const lowerSearch = searchValue.toLowerCase();
    return entitiesWithTypeName.filter(e =>
      e.entityName.toLowerCase().includes(lowerSearch) ||
      e.mei?.toLowerCase().includes(lowerSearch) ||
      e.internalId?.toLowerCase().includes(lowerSearch) ||
      e.entityTypeName.toLowerCase().includes(lowerSearch) ||
      e.systemId?.toLowerCase().includes(lowerSearch)
    );
  }, [entitiesWithTypeName, searchValue]);

  useEffect(() => {
    setSearchValue('');
  }, [dropdownOpen])


  // When the user clicks a row in the table, immediately update the parent's selection.
  const handleSelectChange = useCallback(
    (id: string) => {
      // Immediately notify parent of the new selection.
      selectEntity(id);
      // Optionally, close the dropdown.
      setDropdownOpen(false);
    },
    [filteredEntities]
  );

  return (
    <SelectWithTable
      searchValue={searchValue}
      open={dropdownOpen}
      setOpen={setDropdownOpen}
      setSearchValue={setSearchValue}
      disabled={false}
    >
      <TradeEntryEntityTable
        data={filteredEntities}
        handleSelectChange={handleSelectChange}
        searchValue={searchValue}
      />
    </SelectWithTable>
  );
}
